import React from "react";
import PropTypes from "prop-types";
import { Input } from "semantic-ui-react";
import { debounce } from "lodash";

const propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  transparent: PropTypes.bool,
  placeholder: PropTypes.string
};

class CustomInput extends React.Component {
  constructor(props) {
    super(props);
    this.changed = debounce(this.props.onChange, 500);
    this.state = {
      value: this.props.value || ""
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ value: nextProps.value });
  }

  changed({ value, name }) {
    this.props.onChange({ value, name });
  }

  handleChange = (e, { value, name }) => {
    this.setState({ value });
    this.changed({ value, name });
  };

  render() {
    return (
      <Input
        transparent={this.props.transparent || false}
        disabled={this.props.disabled || false}
        placeholder={this.props.placeholder || ""}
        onChange={this.handleChange}
        value={this.state.value}
        label={this.props.label}
        name={this.props.name}
      />
    );
  }
}

CustomInput.propTypes = propTypes;

export default CustomInput;



// WEBPACK FOOTER //
// ./src/pages/shared/CustomInput.jsx